import { useSyncExternalStore } from 'react';
import { addHingeListener, getHinge } from 'expo-hinge';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns whether the device has a hinge, such as the iPhone Duo.
 *
 * The hinge reports every angle change while the device folds, so only its
 * presence is read as the snapshot to avoid re-rendering callers on each update.
 */
export const useIsFoldableDevice = () => {
  return useSyncExternalStore(subscribeToHingeChanges, checkIfDeviceHasHinge);
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function subscribeToHingeChanges(onChange: () => void) {
  const subscription = addHingeListener(onChange);

  return () => {
    subscription.remove();
  };
}

function checkIfDeviceHasHinge() {
  return getHinge() !== null;
}
